import React from 'react';
const bonuses = [{
  title: 'Piano Express 10 Minuti',
  desc: 'Pianifica una sessione completa in meno di 10 minuti.'
}, {
  title: '60 Messaggi Pronti',
  desc: 'Comunicazione professionale con famiglie e giocatori.'
}, {
  title: 'Kit Adattamento Totale',
  desc: 'Soluzioni per gruppi misti, infortuni o assenze.'
}, {
  title: 'Dashboard Progressi',
  desc: 'Monitora ogni giocatore con metriche chiare.'
}, {
  title: '20 Attività di Team Building',
  desc: 'Costruisci un gruppo coeso e motivato.'
}, {
  title: "Borsa dell'Allenatore",
  desc: 'Checklist e materiali essenziali sempre pronti.'
}];
export function BonusSection() {
  return <section className="w-full bg-[#0A0A0A] py-16 px-4" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl sm:text-5xl font-black text-white mb-4 tracking-tight" data-id="element-4">
            🎁 Ricevi anche{' '}
            <span className="text-[#FF6B00]" data-id="element-5">6 Bonus Strategici</span>
          </h2>
          <p className="text-[#B0B0C0] text-lg font-medium mb-5" data-id="element-6">
            Inclusi senza costo aggiuntivo
          </p>
          <span className="inline-flex items-center gap-2 bg-[#16161F] border border-[#FF6B0033] rounded-full px-5 py-2.5 text-sm sm:text-base font-bold" data-id="element-7">
            <span className="text-[#B0B0C0]" data-id="element-8">Valore reale:</span>
            <span className="text-[#FF6B00] line-through" data-id="element-9">€47</span>
            <span className="text-[#B0B0C0]" data-id="element-10">— oggi incluso</span>
            <span className="text-[#00C853] font-black uppercase tracking-wider" data-id="element-11">
              GRATIS
            </span>
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-12">
          {bonuses.map((bonus, i) => <div key={i} className="bg-[#16161F] border border-[#FF6B0033] rounded-2xl p-5 flex flex-col" data-id="element-13">
              <div className="flex items-center justify-between mb-3" data-id="element-14">
                <span className="text-[#FF6B00] font-black text-sm tracking-wider uppercase" data-id="element-15">
                  Bonus 0{i + 1}
                </span>
                <span className="bg-[#00C853]/10 text-[#00C853] text-[10px] font-black px-2.5 py-1 rounded-full uppercase tracking-wider" data-id="element-16">
                  Gratuito
                </span>
              </div>
              <h4 className="text-white font-bold text-lg mb-2 leading-tight" data-id="element-17">
                {bonus.title}
              </h4>
              <p className="text-[#B0B0C0] text-sm font-medium leading-relaxed" data-id="element-18">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}